__webpack_require__.p = "https://portal-dev.runtogether.vn/";